import request from "@/utils/request";

export function palmCharacteristicGetAllForDropdown(params) {
    return request({
        url: "/api/services/app/PalmCharacteristic/GetAllForDropdown",
        method: "GET",
        params
    });
}

export function palmCharacteristicGet(params) {
    return request({
        url: "/api/services/app/PalmCharacteristic/Get",
        method: "GET",
        params
    });
}

export function palmCharacteristicCreate(data) {
    return request({
        url: "/api/services/app/PalmCharacteristic/Create",
        method: "POST",
        data
    });
}

export function palmCharacteristicUpdate(data) {
    return request({
        url: "/api/services/app/PalmCharacteristic/Update",
        method: "PUT",
        data
    });
}

export function palmCharacteristicDelete(params) {
    return request({
        url: "/api/services/app/PalmCharacteristic/Delete",
        method: "DELETE",
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/palm_characteristic.js